import * as React from "react";

function SvgImageMask(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M8 1a1 1 0 011-1h14a1 1 0 011 1v14a1 1 0 01-1 1h-7v-1h6.5a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5V8H8V1z"
        fill="#414042"
      />
      <path
        d="M9 8h5.546C15.282 8 16 8.727 16 9.455V15h-.727V9.455c0-.364-.364-.728-.727-.728H9V8zM8 8H1.455C.718 8 0 8.727 0 9.5v13.046C0 23.282.727 24 1.455 24h13.09c.728 0 1.455-.718 1.455-1.454V16h-.727v6.546c0 .363-.364.727-.727.727H1.455c-.364 0-.728-.364-.728-.727V9.455c0-.364.364-.728.728-.728H8V8z"
        fill="#414042"
      />
      <path
        d="M8 9.455H2.182c-.364 0-.727.363-.727.727v10.182l5.09-5.819 2.182 2.91L10.182 16l4.364 4.364V16H9a1 1 0 01-1-1V9.455z"
        fill="#414042"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.546 15v-4.818c0-.364-.364-.727-.728-.727H9V14.5a.5.5 0 00.5.5h5.046zM11.5 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgImageMask;
